import { Box } from "@mui/material"
import React, { PropsWithChildren } from "react"
import { Header } from "../header"

const CALL_CARD_MAX_ASPECT_RATIO = "16 / 9"

const brandBackground = {
  backgroundImage: "var(--call-brand-background, none)",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
}

interface CallShellProps {
  isEmbed: boolean
}

export function CallShell({
  isEmbed,
  children,
}: PropsWithChildren<CallShellProps>) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100dvh",
        width: "100%",
        overflow: "hidden",
        backgroundColor: "var(--color-background-bg-page)",
        ...brandBackground,
      }}
    >
      {!isEmbed && <Header />}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          containerType: "size",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingX: isEmbed ? 0 : "var(--call-shell-gutter)",
          paddingY: isEmbed
            ? 0
            : {
                xs: "var(--spacing-tokens-size-in-px-spacing-spacing-xl)",
                md: "var(--spacing-tokens-size-in-px-spacing-spacing-6xl)",
              },
        }}
      >
        <CallCard isEmbed={isEmbed}>{children}</CallCard>
      </Box>
    </Box>
  )
}

function CallCard({ isEmbed, children }: PropsWithChildren<CallShellProps>) {
  return (
    <Box
      sx={
        isEmbed
          ? {
              position: "relative",
              width: "100%",
              height: "100%",
              overflow: "hidden",
              backgroundColor: "var(--color-background-bg-page-contrast)",
              ...brandBackground,
            }
          : {
              position: "relative",
              width: {
                xs: "100%",
                md: "min(100%, calc(100cqh * 16 / 9))",
              },
              height: {
                xs: "100%",
                md: "min(100%, calc(100cqw * 9 / 16))",
              },
              overflow: "hidden",
              borderRadius: "var(--call-card-radius)",
              border: "1px solid var(--call-card-border)",
              backgroundColor: "var(--color-background-bg-page-contrast)",
              ...brandBackground,
            }
      }
    >
      {children}
    </Box>
  )
}
